/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 16:12:31
 * @LastEditTime: 2019-09-12 11:11:15
 * @LastEditors: 李方强
 */
import Vue from 'vue'
import Vuex from 'vuex'
import test from './modules/test'
import work from './modules/work'
import knowledgeSearch from './modules/knowledgeSearch'

Vue.use(Vuex)

// state
let state = {
  token: '',
  userId: '',
  sessdatas: {},
  buttonAll: []
}

// getters
const getters = {
  getsessdatas: state => state.sessdatas,
  getbuttonAll: state => state.buttonAll
}


// actions
const actions = {
  setdatas({ commit, state}, val) {
    commit('SETDATAS', val)
  },
  setbuttonAll({ commit, state}, val) {
    commit('SETBUTTONALL', val)
  }
}

// mutations
const mutations = {
  SETDATAS(state, val) {
    state.sessdatas = val
  },
  SETBUTTONALL(state, val) {
    state.buttonAll = val
  }
}

const store = new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    test,
    work,
    knowledgeSearch
  },
  strict: false
})

export default store
